/** Ashe AbilitySpec seed kit (legacy ids preserved for Entity). */
export const ASHE_ABILITY_DEFS = [
  {
    id: 'q_rangers_focus',
    champKey: 'ashe',
    slot: 'Q',
    name: 'Concentración del Guardián',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 5,
    manaCost: 30,
    vfxId: 'ashe_q',
    duration: 6,
    type: 'buff_autoattack',
    status: 'wired',
    description: 'Aumenta el daño de auto-ataques y dispara una ráfaga de 5 flechas de hielo.'
  },
  {
    id: 'w_volley',
    champKey: 'ashe',
    slot: 'W',
    name: 'Descarga de Flechas en Abanico',
    targeting: 'skillshot_cone',
    range: 1200,
    castTime: 0.25,
    travelSpeed: 2000,
    width: null,
    radius: 8,
    cooldown: 18,
    manaCost: 75,
    vfxId: 'ashe_w',
    projectilesCount: 7,
    coneAngleRad: 0.5,
    baseDamage: 80,
    type: 'skillshot_cone',
    status: 'wired',
    description: 'Dispara 7 flechas de hielo en abanico (0.5 rad) que dañan al primer objetivo alcanzado.'
  },
  {
    id: 'e_hawkshot',
    champKey: 'ashe',
    slot: 'E',
    name: 'Disparo de Halcón',
    targeting: 'global_vision',
    range: 25000,
    castTime: 0,
    travelSpeed: 1400,
    width: null,
    radius: 4,
    cooldown: 5,
    manaCost: 0,
    maxCharges: 2,
    recharge: 90,
    vfxId: 'ashe_e',
    visionRadius: 4,
    visionDuration: 5,
    type: 'global_vision',
    status: 'wired',
    description: 'Lanza un Halcón Espíritu (2 cargas, recarga 90s, CD estático 5s).'
  },
  {
    id: 'r_crystal_arrow',
    champKey: 'ashe',
    slot: 'R',
    name: 'Flecha de Cristal Encantada',
    targeting: 'skillshot_line',
    range: 20000,
    castTime: 0.25,
    travelSpeed: 1500,
    width: null,
    radius: 24,
    cooldown: 100,
    manaCost: 100,
    vfxId: 'ashe_r',
    baseDamage: 200,
    stunMinDuration: 1,
    stunMaxDuration: 3.5,
    type: 'global_skillshot_stun',
    status: 'wired',
    description: 'Flecha global que aturde al primer enemigo (1.0–3.5s según distancia).'
  }
];
